import {Injectable} from '@angular/core';
import {SyncTable} from './sync.table';
import {Table} from 'dexie';
import {SyncItem} from '../interfaces/core/sync-item';


@Injectable({
  providedIn: 'root'
})
export abstract class SecureTable<T extends SyncItem> extends SyncTable<T> {

  /**
   *
   * @param table
   * @protected
   */
  protected constructor(table: Table<T, string>) {
    super(table);
  }
  // -------------------------------------------------------------------------------------------------------------------
  // Single item
  // -------------------------------------------------------------------------------------------------------------------

  // -------------------------------------------------------------------------------------------------------------------
  // Multiple items
  // -------------------------------------------------------------------------------------------------------------------
  public override async set(items: T[]): Promise<void> {
    const _isSynced = await this.isSynced();
    if(_isSynced) {
      return super.set(items);
    }
    throw new Error('Cannot set items, table is not synced');
  }

  /**
   *
   * @param force
   */
  public override async clear(force: boolean = false): Promise<void> {
    if(!force) {
      const synced = await this.isSynced();
      if(!synced) {
        throw new Error('Cannot clear table, it is not synced');
      }
    }
    await super.clear();
  }

}
